export var StompActionskeys;
(function (StompActionskeys) {
    StompActionskeys["CONNECTED"] = "STOMP/CONNECTED";
    StompActionskeys["DISCONNECTED"] = "STOMP/DISCONNECTED";
})(StompActionskeys || (StompActionskeys = {}));
export const connect = () => ({
    type: StompActionskeys.CONNECTED,
});
export const disconnect = () => ({
    type: StompActionskeys.DISCONNECTED,
});
//# sourceMappingURL=actions.js.map